import React from 'react'
import {FaDiscord, FaTwitter} from 'react-icons/fa'
import { RiFilePaper2Line } from 'react-icons/ri'
import whitePaper from '../../whitepaper.pdf'
import openSeaLogo from '../../images/OpenSeaWhite.svg'
import { SidebarContainer, Icon, CloseIcon, SideSocialItem, SideSocialsWrap, SidebarMenu, SidebarLink, SidebarWrapper } from './SidebarElements'
import {DISCORD_URL} from "../../App";

const Sidebar = ({isOpen, toggleMenu}) => {
  return (
    <SidebarContainer isOpen={isOpen} onClick={toggleMenu}>
      <Icon onClick={toggleMenu}>
        <CloseIcon />
      </Icon>
      <SidebarWrapper>
        <SidebarMenu>
          <SidebarLink to="mint" onClick={toggleMenu}>Mint</SidebarLink>
          <SidebarLink to="about" onClick={toggleMenu}>About</SidebarLink>
          <SidebarLink to="brainz" onClick={toggleMenu}>$BRAINZ</SidebarLink>
        </SidebarMenu>
        <SideSocialsWrap>
          <SideSocialItem to={{ pathname: DISCORD_URL }} target="_blank"><FaDiscord size={30}/></SideSocialItem>
          <SideSocialItem to={{ pathname: "https://twitter.com/bit_monsters" }} target="_blank"><FaTwitter size={30}/></SideSocialItem>
          <SideSocialItem to={{ pathname: "https://opensea.io/collection/bit-monsters-nft" }} target="_blank"><img src={openSeaLogo} alt="Open Sea Logo"/></SideSocialItem>
          <SideSocialItem to={whitePaper} target="_blank"><RiFilePaper2Line size={30}/></SideSocialItem>
        </SideSocialsWrap>
      </SidebarWrapper>
    </SidebarContainer>
  )
}

export default Sidebar
